import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { AiSmartCanvasMakeRealCollection } from './ai-smart-canvas-make-real.types';

export function aiSmartCanvasMakeRealBackend(): Backend<AiSmartCanvasMakeRealCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: undefined,
    push: (authUid, document) => {
      return {
        endpoint: 'ai/smart-canvas/make-real.php',
        method: 'POST',
        isGaf: true,
        payload: {
          developerPrompt: document.developerPrompt,
          base64Image: document.base64Image,
          messages: document.messages,
        },
      };
    },
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
